module.exports = __webpack_public_path__ + "static/problem-0da81868ab4426bfee10b84e7ee841fc.png";